export default __webpack_public_path__ + "static/media/time-bound.547e33d6.svg";